module.exports = __webpack_public_path__ + "img/ico-preview-brand-color.9d75efe0.svg";